export const isWorkspaceRow = (depth: number) => depth === 0
